import { useFlow } from "../../../FlowEdit/useFlow";
import { RenderInputProps } from "../types";
import { useState } from "react";
import { Button, message } from "antd";
import { FlowNodeInputTypeEnum } from "@packages/flow-core/module/node/constants";
import { ModuleIOValueTypeEnum } from "@packages/flow-core/module";
import FieldEditModal from "../../FieldEditModal";
import { PlusOutlined } from "@ant-design/icons";

export default function AddKv({ moduleId, inputs }: RenderInputProps) {
  const { addModuleInput } = useFlow();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        type="primary"
        icon={<PlusOutlined />}
      >
        添加客户属性
      </Button>
      <FieldEditModal
        field={{ required: true, description: true, key: true }}
        visible={open}
        onClose={() => setOpen(false)}
        onConfirm={(data) => {
          const existed = inputs?.find((item) => item.key === data.key);
          if (existed) {
            message.warning("字段Key不能重复");
            return;
          }
          addModuleInput(moduleId, {
            type: FlowNodeInputTypeEnum.input,
            key: data.key!,
            label: data.key!,
            edit: true,
            editField: {
              required: true,
              description: true,
              key: true,
            },
            showTargetInApp: true,
            showTargetInPlugin: true,
            valueType: ModuleIOValueTypeEnum.string,
            description: data.description,
            required: data.required,
          });
          setOpen(false);
        }}
      />
      {/* <Modal
        open={open}
        title="添加属性"
        destroyOnClose
        footer={[
          <Button key="confirm" onClick={() => ref.current?.submit()}>
            确认
          </Button>,
        ]}
        onCancel={() => setOpen(false)}
      >
        <Form
          ref={ref}
          onFinish={({ key }) => {
            const existed = inputs?.find((item) => item.key === key);
            if (existed) {
              message.warning('字段Key不能重复');
              return;
            }
            addModuleInput(moduleId, {
              type: FlowNodeInputTypeEnum.input,
              key,
              label: key,
              edit: true,
              editField: {
                key: true,
                required: true,
              },
              showTargetInApp: true,
              showTargetInPlugin: true,
              valueType: ModuleIOValueTypeEnum.string,
            });
            setOpen(false);
          }}
        >
          <Form.Item label="字段Key" name="key" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Form>
      </Modal> */}
    </>
  );
}
